module.exports = __webpack_public_path__ + "img/phone-sentosa.b61d9d94.svg";